export default {
  root: {
    flexWrap: "initial",
  },
};
